<template>
  <!-- 機器予約 -->
  <div id="KenshinDevicePreparationDetail">
    <div id="container">
      <div class="labelTitle lable">企業検診 機器予約</div>
      <div class="button-area"><b-button class="backButton is-primary" v-on:click="back">戻る</b-button></div>
      <div id="item-contens">
        <div class="card-content margin-top">
        <table>
            <tr><th>受付番号</th>
              <td><a @click="showDetail(data.receiptNumber)">{{data.receiptNumber}} <b-icon icon="vector-arrange-above"/></a></td>
            </tr>
            <tr><th>検査種類</th><td>{{getChoiceName(data.inspectionKind,inspectionKindList)}}</td></tr>
            <tr><th>機種</th><td>{{getChoiceName(data.model,kenshinDeviceList)}}</td></tr>
            <tr><th>企業名</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.companyName}}</td></tr>
            <tr><th style="vertical-align: top;">出荷予定日</th>
              <table style="width:350px;">
                <tr v-for="(shippingInfo, index) in data.shippingDate" :key="index" >
                  <td style="width:240px; word-break : break-all;">{{shippingInfo.officeName}}：</td><td style="width:150px;">{{shippingInfo.expectedShippingDate}} </td>
                </tr>
              </table>
            </tr>
            <tr>
              <th style="vertical-align:top;">検診情報備考</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.kenshinNote}}</td>
            </tr>
            <tr>
              <th style="vertical-align:top;">検診グループ受付備考</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.businessBiko}}</td>
            </tr>
            <tr>
              <th style="vertical-align:top;">川越受付備考</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.memo}}</td>
            </tr>
            <tr><th>台数</th><td>{{data.units}}台</td></tr>
            <tr>
              <th style="vertical-align:top;">外部ユーザーコメント</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.belongsNote}}</td>
            </tr>
        </table>
        </div>
        <div class="card-content margin-top" v-for="(destination, index) in data.destinationList" :key="index">
          <div style="text-align:left; margin-left:20px; margin-top:10px;">事業所名：{{destination.enterpriseName}}</div>
          <div style="text-align:left; margin-left:20px; margin-bottom:10px;">配送先：{{destination.deviceDeliveryAddress}}</div>
          <b-table
              id="kenshinDevicePreparationDetailTable"
              :data="destination.kenshinPatientList">
              <template slot-scope="props">
                <b-table-column label="#" width="40" class="emphasis" centered>
                  {{ props.index + 1 }}
                </b-table-column>
                <b-table-column field="serial" label="シリアル" width="100" centered>
                  <input :disabled="destination.status==requestStatus.shippingReady" type="text" :id="'serial' + props.index" v-model="props.row.serial" @keyup.enter="onKeyupEnter(props.row, props.index)" @focus="isButtonDisable=true" @input="isButtonDisable=true" @blur="focusLost(props.row)" class="serial" :name="'受付番号:'+props.row.receiptNumber+' のシリアル'" validate="required" :officeReceptionBranchNo="destination.officeReceptionBranchNo"/>
                </b-table-column>
                <b-table-column field="leaseupDate" label="リースアップ日" width="140" centered>
                  {{props.row.leaseupDate}}
                </b-table-column>
                <b-table-column field="serial" label="受付番号" width="90" centered>
                  {{props.row.receiptNumber}}
                </b-table-column>
                <b-table-column field="patientName" label="名前" width="100" sortable >
                  {{props.row.patientName}}
                </b-table-column>
                <b-table-column field="employeeNumber" label="社員番号" width="90" sortable centered>
                  {{props.row.employeeNumber}}
                </b-table-column>
                <b-table-column field="birthday" label="生年月日" width="90" sortable centered>
                  {{props.row.birthday}}
                </b-table-column>
                <b-table-column field="gender" label="性別" width="60" sortable centered>
                  {{props.row.gender}}
                </b-table-column>
                <b-table-column field="address" label="備考" width="180" sortable>
                  {{props.row.remarks}}
                </b-table-column>
              </template>
          </b-table>
          <b-button v-if="destination.status==requestStatus.deviceReady" class="receptionistButton is-primary" @click="receptionist(destination.officeReceptionBranchNo)" :disabled="isButtonDisable">機器予約</b-button>
          <b-button v-if="destination.status==requestStatus.deviceReady" class="receptionistButton is-primary" @click="tempSave(destination.officeReceptionBranchNo)" :disabled="isButtonDisable">一時保存</b-button>
          <b-button v-if="destination.status==requestStatus.shippingReady" style="background-color:RGB(242,242,242);" :disabled="true">機器予約済み</b-button>
        </div>
        <div class="button-area">
          <b-button class="backButton is-primary" @click="back">戻る</b-button>
        </div>
      </div>
    </div>
    <floatingDiv v-if="isShowDetail" @close="closeDetail" title="" width="900px" height="480px" top="100px" right="100px">
      <kenshinRequestDetail :data="data.applicationDetails"/>
    </floatingDiv>
  </div>
</template>

<script>
import floatingDiv from "@/components/mock/common/FloatingDiv";
import KenshinRequestDetail from "@/components/mock/common/KenshinRequestDetail";
import {choicesType} from "@/components/mock/base/const.js";
import {requestStatus} from "@/components/mock/base/const.js";

export default {
  name: "KenshinDevicePreparationDetail",
  methods: {
    back: function () {
      this.$router.push({
        name: "KenshinDevicePreparation",
        params: { searchConditions: this.searchParams },
      });
    },
    getChoiceName: function(val,list) {
      var target = list.find(item => item.value == val)
      if(target){
        return target.label1
      }
      return ""
    },
    isDuplicateSerial: function() {
      // シリアルの重複チェック
      const serialList = []
      for(let destination of this.data.destinationList){
        destination.kenshinPatientList.map((item) =>{
          if(item.serial){
            serialList.push(item.serial)
          }
        });
      }
      const setElements = new Set(serialList);
      if (setElements.size !== serialList.length) {
        return true
      }
      return false
    },
    receptionist: function(officeReceptionBranchNo) {
      // 機器予約
      // バリデーションチェック（配送先の枠内で確認する）
      var elements = document.getElementsByClassName("serial")
      elements = Array.from(elements).filter(val => val.getAttribute("officeReceptionBranchNo") == officeReceptionBranchNo)
      var result = this.selfMadeValidation(elements)
      if(result.msg){
        this.showErrorMessage(result.msg)
      }else{
        if(this.isDuplicateSerial()){
          this.showErrorMessage("重複しているシリアル番号があります。")
          return
        }
        this.targetOfficeReceptionBranchNo = officeReceptionBranchNo;
        var excuteApi = this.setKenshinDeviceReservePOST;
        var successCallBack = this.setKenshinDeviceReservePOSTSuccess;
        var errorCallBack = this.setKenshinDeviceReservePOSTError;
        // Web Api Call
        this.apiCall(excuteApi, successCallBack, errorCallBack);
      }
    },
    setKenshinDeviceReservePOST: function(client) {
        var obj = JSON.parse(JSON.stringify(this.data));
        delete obj.applicationDetails
        if(this.targetOfficeReceptionBranchNo){
          obj.receiptNumber = obj.receiptNumber + "-" + this.targetOfficeReceptionBranchNo
        }
      return client.apis.internalKenshin.setKenshinDeviceReservePOST({
        body:obj
      });
    },
    setKenshinDeviceReservePOSTSuccess: function(result) {
      this.showSuccess(result,this.back());
    },
    setKenshinDeviceReservePOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    tempSave: function(officeReceptionBranchNo) {
      if(this.isDuplicateSerial()){
        this.showErrorMessage("重複しているシリアル番号があります。")
        return
      }
      this.targetOfficeReceptionBranchNo = officeReceptionBranchNo;
      // 一時保存
      var excuteApi = this.setKenshinDeviceTempSavePOST;
      var successCallBack = this.setKenshinDeviceTempSavePOSTSuccess;
      var errorCallBack = this.setKenshinDeviceTempSavePOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setKenshinDeviceTempSavePOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.data));
      if(this.targetOfficeReceptionBranchNo){
        obj.receiptNumber = obj.receiptNumber + "-" + this.targetOfficeReceptionBranchNo
        var targetDestinationList = obj.destinationList.filter(val => val.officeReceptionBranchNo == this.targetOfficeReceptionBranchNo)
        for(let destination of targetDestinationList){
          for(let patient of destination.kenshinPatientList){
            if(!patient.serial){
              patient.serial = ""
            }
          }
        }
      }
      delete obj.applicationDetails
      return client.apis.internalKenshin.setKenshinDeviceTempSavePOST({
        body:obj
      });
    },
    setKenshinDeviceTempSavePOSTSuccess: function(result) {
      this.showSuccess(result);
    },
    setKenshinDeviceTempSavePOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    showDetail: function() {
      this.isShowDetail = true;
    },
    closeDetail: function(){
      this.isShowDetail = false;
    },
    onKeyupEnter: function(rowItem, index){
      if(!rowItem.serial){
        return
      }
      //シリアルを取得
      let serialItems = rowItem.serial.split('/');
      if(serialItems.length == 2){
        //　"/"が含まれていたらそれ以降の文字に変更する
        rowItem.serial = serialItems[1]
      }
      if(rowItem.serial){
        var cnt = index + 1
        var nextElement = null
        while(cnt < this.data.destinationList[0].kenshinPatientList.length && !nextElement){
          nextElement = document.getElementById("serial" + (cnt));
          if(nextElement.disabled){
            nextElement = null
            cnt++
          }
        }
        if(nextElement){
          // 次のアイテムが存在する場合、フォーカスを移動
          this.focusTarget = nextElement
          nextElement.focus();
        }else{
          // 次のアイテムが存在しない場合、フォーカスを外す
          let element = document.getElementById("serial" + (index));
          element.blur();
        }
      }
    },  
    focusLost: async function (rowItem) {
      this.searchTarget = rowItem
      if(rowItem.serial){
        var excuteApi = this.getMachineDetailPOST;
        var successCallBack = this.getMachineDetailPOSTSuccess;
        var errorCallBack = this.getMachineDetailPOSTError;
        // WebAPI Call
        await this.apiCall(excuteApi, successCallBack, errorCallBack);
      }else{
        this.isButtonDisable = false
        this.$set(this.searchTarget,"leaseupDate","")
        this.$set(this.searchTarget,"reserveTime","")
      }
    },
    getMachineDetailPOST: function(client) {
      return client.apis.apiCommon.getMachineDetailPOST({ 
        body: {
          serial:this.searchTarget.serial,
          modelId:this.data.model
        } 
      });
    },
    getMachineDetailPOSTSuccess: function(result) {
      var machineDetail = result.obj;
      if(this.isPastday(machineDetail.leaseupDate)){
        // リースアップ日を超えている場合は、警告メッセージ
        var messsge = machineDetail.leaseupDate + "にリースアップ日を超過している機器です。";
        this.$dialog.alert({
          title: '　',
          message: messsge,
        })
        this.$set(this.searchTarget,"serial","")
      }else if(this.isSoon(machineDetail.leaseupDate,2)){
        // リースアップ日が2ヶ月以内の場合近づいている場合は、警告メッセージ
        var messsge = machineDetail.leaseupDate + "にリースアップする機器です。";
        let _this = this;
        this.$dialog.alert({
          title: '　',
          message: messsge,
          onConfirm: () => {
            if(_this.focusTarget){
              _this.focusTarget.focus();
              _this.focusTarget = null
            }
          }
        })
        this.$set(this.searchTarget,"serial","")
      }else{
        // リースアップ日をセット
        this.$set(this.searchTarget,"leaseupDate",machineDetail.leaseupDate)
        // 機器予約コードをセット
        this.$set(this.searchTarget,"reserveTime",new Date().getTime())
      }
      this.isButtonDisable = false
    },
    getMachineDetailPOSTError: function(result) {
      // シリアルに一致する利用可能な機器が存在しない場合
      this.$set(this.searchTarget,"serial","")
      this.$set(this.searchTarget,"leaseupDate","")
      this.$set(this.searchTarget,"reserveTime","")
      this.showErrorMessage(result);
      this.isButtonDisable = false
    },
    doSearch: function() {
      var excuteApi = this.getKenshinDevicePreparationDetailPOST;
      var successCallBack = this.getKenshinDevicePreparationDetailPOSTSuccess;
      var errorCallBack = this.getKenshinDevicePreparationDetailPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getKenshinDevicePreparationDetailPOST: function(client) {
      return client.apis.internalKenshin.getKenshinDevicePreparationDetailPOST({
        body:{receiptNumber:this.targetNumber}
      });
    },
    getKenshinDevicePreparationDetailPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj
    },
    getKenshinDevicePreparationDetailPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result,this.back());
    },
  },
  data() {
    var targetNumber = decodeURIComponent(this.$route.query["receiptNumber"]);
    var searchParams = this.$route.params["searchConditions"];
    let inspectionKindList = this.getChoiceList(choicesType.kenshinKind, false);
    inspectionKindList.unshift({})
    let kenshinDeviceList = this.getChoiceList(choicesType.kenshinDevice, false);
    kenshinDeviceList.unshift({})
    return {
      targetNumber,
      searchParams,
      data: {},
      inspectionKindList,
      kenshinDeviceList,
      isShowDetail: false,
      searchTarget:{},
      focusTarget:null,
      isButtonDisable:false,
      targetOfficeReceptionBranchNo:null,
      requestStatus
    };
  },
  async mounted() {
    // 機種マスタ取得
    await this.doSearch();
  },
  filters: {},
  components: { 
    floatingDiv: floatingDiv,
    kenshinRequestDetail:KenshinRequestDetail
  }
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}
table.flowTable,
table.flowTable tr,
table.flowTable td {
    border: 1px solid;
    padding: 0px;
    vertical-align: middle;
}
table.flowTable td {
    width: 40px;
    text-align: center;
}

.delay {
    font-weight: bold; 
}
.delay ,
.error {
    color: red;
    margin-left:5px;
}

</style>


// WEBPACK FOOTER //
// src/components/mock/philips/kenshin/KenshinDevicePreparationDetail.vue